<template>
    <div class="mb-4 download-container flex flex-col items-center justify-evenly">
        <div>
            <img srcset="@/assets/images/ic-logo-eostre.jpg,
                @/assets/images/ic-logo-eostre@2x.jpg 2x,
                @/assets/images/ic-logo-eostre@3x.jpg 3x"
                src="@/assets/images/ic-logo-eostre@3x.jpg"
                alt="Eostre logo"
            >
        </div>

        <h1 class="title blue-dark">{{ $t('download.title') }}</h1>

        <div v-if="isIOS || isNotMobile">
            <a :href="iosLink">
                <img srcset="@/assets/images/img-apple-store-download.jpg,
                    @/assets/images/img-apple-store-download@2x.jpg 2x,
                    @/assets/images/img-apple-store-download@3x.jpg 3x"
                    src="@/assets/images/img-apple-store-download@3x.jpg"
                    alt="Apple App Store logo"
                >
            </a>
        </div>

        <div v-if="isAndroid || isNotMobile" class="flex flex-col">
            <a :href="googlePlayLink">
                <img srcset="@/assets/images/img-google-download.jpg,
                    @/assets/images/img-google-download@2x.jpg 2x,
                    @/assets/images/img-google-download@3x.jpg 3x"
                    src="@/assets/images/img-google-download@3x.jpg"
                    alt="Google Play logo"
                >
            </a>

            <a :href="androidLink"
                class="android-link w-full inline-block rounded flex justify-center items-center mt-8">
                {{ $t('download.download_app') }}
            </a>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/css/color';

.download-container {
    height: 70vh;
}

.android-link {
    height: 50px;
    color: $white;
    background: $blue-dark;
}
</style>

<script>
export default {
    data () {
        return {
            iosLink: process.env.VUE_APP_IOS_LINK,
            googlePlayLink: process.env.VUE_APP_ANDROID_GOOGLEPLAY_LINK,
            androidLink: process.env.VUE_APP_ANDROID_LINK
        }
    },
    computed: {
        isNotMobile () {
            return !this.isIOS && !this.isAndroid
        },
        isIOS () {
            return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        },
        isAndroid () {
            return /android/i.test(navigator.userAgent)
        }
    }
}
</script>
